import { Box, Stack, Typography } from "@mui/material";
import MainWrapper from "../../components/helpers/MainWrapper";
import Safety from "../../images/safety.WEBP";
import Sarodi from "../../images/sarodi.svg";
import UpArrow from "../../images/up-arrow.svg";
import { FC } from "react";

interface Props {
  onClickToTop: () => void;
}

const ProductionDesign: FC<Props> = ({ onClickToTop }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <Box
        sx={{
          paddingTop: { xs: "3rem", lg: "5rem", xl: "8rem" },
          left: { xs: "1rem", md: "5rem" },
          alignItems: "flex-end",
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          gap: ".5rem",
        }}
      >
        <Box
          sx={{
            width: { xs: "8rem", md: "15rem" },
          }}
        >
          <img
            src={Sarodi}
            style={{
              paddingLeft: "10rem",
              width: "100%",
              height: "100%",
            }}
            alt="Sarodi icon."
          />
        </Box>
        <Box
          sx={{
            width: "2px",
            minHeight: "65dvh",
            background: "#8B8B8B",
          }}
        />
        <Box
          onClick={onClickToTop}
          sx={{
            cursor: "pointer",
            marginLeft: "-.9rem",
            width: { xs: "25px", md: "40px" },
          }}
        >
          <img width="100%" height="100%" src={UpArrow} alt="Up arrow" />
        </Box>
      </Box>
      <MainWrapper>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "flex-end" },
            gap: { xs: "1rem", md: "10rem" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <Stack gap=".5rem">
              <Typography color="#6B9EAA">جایگاه جدید</Typography>
              <Typography
                variant="h3"
                fontSize={{ xs: "1.2rem", md: "1.8rem" }}
              >
                گروه طراحی و تولیدی{" "}
                <Typography
                  component="span"
                  fontWeight="bold"
                  fontSize={{ xs: "1.2rem", md: "1.8rem" }}
                >
                  ایمن آب
                </Typography>
              </Typography>
            </Stack>
            <Box
              sx={{
                width: { xs: "90%", lg: "400px", xl: "530px" },
              }}
            >
              <img width="100%" height="100%" src={Safety} alt="Safety" />
            </Box>
          </Box>
          <Typography
            sx={{
              fontSize: { xs: "12px", md: "14px" },
              color: "#2E2E2E",
              maxWidth: { xs: "90%", md: "100%" },
              textAlign: "justify",
            }}
          >
            به عنوان بخشی از استراتژی ریبرندنیگ ما، برند ایمن آب به یک هلدینگ
            صنعتی تبدیل خواهد شد. ایمن آب همچنان به عنوان برند مادر، نقش حیاتی
            خود را در این صنعت ایفا خواهد کرد و بر خانواده ای از برندهای متعهد،
            به تعالی و پایداری نظارت خواهد کرد. سارودی یک برند زیرمجموعه در
            هلدینگ ایمن آب و پیشرو در تولید و عرضه تجهیزات بهداشتی ساختمانی
            پایدار خواهد بود.
            <br /> به عنوان بخشی از استراتژی ریبرندنیگ ما، برند ایمن آب به یک
            هلدینگ صنعتی تبدیل خواهد شد. ایمن آب همچنان به عنوان برند مادر، نقش
            حیاتی خود را در این صنعت ایفا خواهد کرد و بر خانواده ای از برندهای
            متعهد، به تعالی و پایداری نظارت خواهد کرد. سارودی یک برند زیرمجموعه
            در هلدینگ ایمن آب و پیشرو در تولید و عرضه تجهیزات بهداشتی ساختمانی
            پایدار خواهد بود.
          </Typography>
        </Box>
      </MainWrapper>
    </Box>
  );
};

export default ProductionDesign;
